import React from "react";
import FlatButton from "@material-ui/core/Button";
import theme from "styles/theme";
import color from "color";
import { VIEWPORT_PHABLET, VIEWPORT_MOBILE } from "constants/media";
import { makeStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

const useStyles = makeStyles<Theme, { primary: boolean; large: boolean; mobile: boolean }>({
    root: ({ primary, large, mobile }) => ({
        border: primary
            ? `1px solid ${(theme.palette as any).primary1Color}`
            : `1px solid ${(theme.palette as any).lightGrey}`,
        borderRadius: large ? "25px" : "20px",
        textTransform: "none",
        whiteSpace: "nowrap",
        padding: mobile ? "0 16px" : "0 32px",
        fontFamily: "Lato, sans-serif",
        fontSize: large ? "20px" : "14px",
        height: large ? "50px" : "40px",
        lineHeight: "40px",
        color: primary ? "white" : (theme.palette as any).darkGrey,
        fontWeight: 400,
        position: "relative",
        top: "-1px",
        backgroundColor: primary ? theme.palette.accent1Color : "white",
        userSelect: "none",
        overflow: "hidden",
        "&:hover": {
            backgroundColor: primary
                ? color(theme.palette.accent1Color).darken(0.05).rgbString()
                : (theme.palette as any).lightestGrey,
        },
        "& .MuiButton-label": {
            background: "transparent",
        },
        "&:disabled": {
            color: primary ? "white" : (theme.palette as any).grey,
        },
    }),
    disabled: ({ primary }) => {
        if (primary) {
            return {
                backgroundColor: color(theme.palette.accent1Color).desaturate(0.4).lighten(0.4).rgbString(),
            };
        } else {
            return {
                border: `1px solid ${(theme.palette as any).lighterGrey}`,
            };
        }
    },
});

interface IProps {
    primary?: boolean;
    large?: boolean;
    style?: object;
    disabled?: boolean;
    segmented?: boolean;
    viewport?: string;
    label: string;
    onClick: (e: React.MouseEvent<HTMLElement>) => void;
    fullWidth?: boolean;
}

const Button = (props: IProps) => {
    const {
        primary = false,
        large = false,
        style = {},
        disabled,
        segmented,
        onClick,
        viewport,
        label,
        ...other
    } = props;
    const mobile = [VIEWPORT_MOBILE, VIEWPORT_PHABLET].includes(viewport);
    const classes = useStyles({ primary, large, mobile });
    const className = `${classes.root} ${disabled ? classes.disabled : ""}`;
    return (
        <FlatButton className={className} disabled={disabled} onClick={onClick} {...other} style={{ ...(style || {}) }}>
            {label}
        </FlatButton>
    );
};

export default Button;
